/* eslint-disable no-console */
import React, { useState } from 'react';
import { getApiErrorMessage, getDateInDDMMYYYY } from '../../utils/commonUtils';
import { RenewalDatePayload, updateRenewalDate } from './cryoStorage.helpers';
import EditIcon from '@mui/icons-material/EditOutlined';  
import { useAlert } from '../../components/alertProvider';

interface EditableDateCellProps {
  cryo_date?: string;
  itemId: number;
  type: string;
  onDateChange: (newDate: string) => void;
}

const EditableDateCell: React.FC<EditableDateCellProps> = ({ cryo_date, itemId, type, onDateChange }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedDate, setEditedDate] = useState<string>(cryo_date || new Date().toISOString().split('T')[0]);
  const [lastSavedDate, setLastSavedDate] = useState<string>(cryo_date || '');
  const { addAlert } = useAlert();

  // Only update local state on change
  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditedDate(e.target.value);
  };

  // Only trigger API and parent callback on blur, and only if the date changed
  const handleBlur = () => {
    if (editedDate !== lastSavedDate) {
      setIsEditing(false);
      const payload: RenewalDatePayload = {
        id: itemId,
        renewal_date: editedDate ? editedDate : null,
        type,
      };
      updateRenewalDate(payload)
        .then(() => {
          setLastSavedDate(editedDate);
          onDateChange(editedDate);
        })
        .catch((error) => {
          const errorMessage = getApiErrorMessage(error, 'Failed to update renewal date.');
          addAlert(errorMessage, 'error');
        });
    } else {
      setIsEditing(false);
    }
  };

  return (
    <div style={{ textAlign: 'left' }}>
      {isEditing ? (
        <input
          type="date"
          value={editedDate || undefined}
          onChange={handleDateChange}
          onBlur={handleBlur}
          autoFocus
          style={{ cursor: 'pointer', border: 'none' }}
        />
      ) : (
        <div onClick={() => setIsEditing(true)} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
          {cryo_date ? getDateInDDMMYYYY(cryo_date) : 'dd-mm-yyyy'}
          <EditIcon sx={{ fontSize: 'small', ml: 1, cursor: 'pointer', color: '#3A80E2' }} />
        </div>
      )}
    </div>
  );
};

export default EditableDateCell;
